import { render, staticRenderFns } from "./PrivatePolicy.vue?vue&type=template&id=ae0ddad6&scoped=true"
import script from "./PrivatePolicy.vue?vue&type=script&lang=js"
export * from "./PrivatePolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0ddad6",
  null
  
)

export default component.exports